import React, { useState, useEffect, useCallback } from 'react';
import { View, ActivityIndicator } from 'react-native';
import { useBoundStore, usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';
import { router, useFocusEffect } from 'expo-router';
import ArticleModal from './ArticleModal';
import PageNavigation from './PageNavigation';
import ViewerComponent from './ViewerComponent.web';
import { getApiEditionID, getApiPageFiles } from '@/services/FetchFromAPI';
import { pageFiles } from '@/services/datatypes/pdf';
import { useUpdateSubscriptions } from '@/services/auth/useUpdateSubscriptions';
import { useGetSubscriptions } from '@/services/apis/typo3/useGetSubscriptions';
import { useHasAccess } from '@/services/apis/typo3/useHasAccess';

const Viewer = () => {
  const currentMagazine = useBoundStore((state) => state.magazine);
  const updateCurrentMagazine = useBoundStore((state) => state.updateCurrentMagazine);
  const user = usePersistSecureBoundStore((state) => state.user);
  const token = usePersistBoundStore((state) => state.token);
  const updateSubscriptions = usePersistSecureBoundStore((state) => state.updateSubscriptions);
  const [loading, setLoading] = useState(true);
  const [preparing, setPreparing] = useState(true);
  const [isMounted, setIsMounted] = useState(false);
  const { getSubscriptions } = useGetSubscriptions();
  const [acces, setAccess] = useState<boolean>(false);
  const {hasAccess} = useHasAccess();

  useFocusEffect(
    useCallback(() => {
      setIsMounted(true);
      return () => {
        updateCurrentMagazine(null);
        setLoading(true);
      };
    }, [])
  );

  useEffect(()=>{
    if(!loading && !acces) router.push('/(tabs)/');
  },[loading]);

  const checkSubscriptions = async () => {
    if (user && token && currentMagazine) {
      console.log("Viewer - user", user);
      console.log("Viewer - currentMagazine", currentMagazine);
      const subscriptions =  (await getSubscriptions(token)).entries;
      console.log("Viewer - subscriptions", subscriptions);
      updateSubscriptions(subscriptions);
      setAccess(hasAccess(subscriptions));      
    } else {
      setAccess(false);
    }
  }


  useEffect(() => {
    //console.log("Viewer - currentMagazine", currentMagazine);
    if (!isMounted) return;
    setLoading(true);
    setPreparing(true);

    const onUpdateCurrentMagazine = async () => {
      if (currentMagazine) {
        const apiEditionId = await getApiEditionID(currentMagazine?.edition, currentMagazine?.date);
        //console.log("Viewer - apiEditionId", apiEditionId);
        const pageInfo = await getApiPageFiles(apiEditionId);
        //console.log("Viewer - pageFiles", JSON.parse(pageInfo));
        const newPageFiles: pageFiles[] = JSON.parse(pageInfo).map((p: any) => {
          return {
            page: p.pageNumber,
            pageStatus: p.pageStatus,
            ressort: p.ressort,
            downloaded: false,
            filesize: 0,
            api_id: p.id
          }
        });
        //console.log("Viewer - currentMagazine - newPageFiles: ", newPageFiles);
        const newMagazine = currentMagazine;
        newMagazine.pageFiles = newPageFiles;
        updateCurrentMagazine(newMagazine);
        await checkSubscriptions();
        setPreparing(false);
      }
      
    };

    onUpdateCurrentMagazine();
  }, [currentMagazine, isMounted]);

  useEffect(() => {
    const onPrepared = async () => {
      //console.log("Viewer - preparing");
      if (currentMagazine && currentMagazine.pageFiles) {
        setLoading(false);
      }
    }
    if (!preparing) onPrepared();
  }, [preparing]);

  if (!isMounted) return null;
  return (
    <View style={{ flex: 1, justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
      {loading ? (
        <ActivityIndicator size="large" color="#0000ff" />
      ) : (
        <>
          {currentMagazine?.pageFiles && <ViewerComponent magazineDataForViewer={currentMagazine.pageFiles} />}
          {//@ts-ignore - it does not get the difference for the .web import
            currentMagazine?.pageFiles && <PageNavigation magazineDataForViewer={currentMagazine.pageFiles} />}
          {<ArticleModal />}
        </>
      )}
    </View>
  );
}

export default Viewer;